import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogConfig as MatDialogConfig,
  MatLegacyDialog as MatDialog,
} from '@angular/material/legacy-dialog';
import { log } from 'console';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-uvr-action-dialog',
  templateUrl: './uvr-action-dialog.component.html',
  styleUrls: ['./uvr-action-dialog.component.scss'],
})
export class UvrActionDialogComponent implements OnInit {
  submitted: boolean = false;
  business_entity: any;
  checkMode: any;
  toOrder: any;
  isLotsSelected: boolean = true;
  errorMessage1: any;
  textDate: any;
  TextDateTo: any;
  addCommentEventEmitter = new EventEmitter();
  addManualOrderEventEmitter = new EventEmitter();
  addTapRequestEventEmitter = new EventEmitter();
  addRecalculateEventEmitter = new EventEmitter();
  label = '# OF LOTS';
  addCommentform: UntypedFormGroup = this.formBuilder.group({
    // comment: ['', Validators.required],
    comment: [''],
  });
  addManualform: UntypedFormGroup = this.formBuilder.group({
    qty: ['', Validators.required],
    orderType: ['', Validators.required],
  });
  addTapRequestform: UntypedFormGroup = this.formBuilder.group({
    // comment: ['', Validators.required],
    qty: ['', Validators.required],
    orderType: ['', Validators.required],
    date_by_when: ['', Validators.required],
  });

  warningMessage: string;
  itContact: any;
  successMessage: string;
  partNumber: any;

  ngOnInit(): void {
    this.business_entity = localStorage.getItem('namcvalue');
    this.toOrder = [{ order_type: 'Lots' }, { order_type: 'Pieces' }];

    if (this.data?.mode === 'addComment') {
      this.checkMode = 'addComment';
    } else if (this.data?.mode === 'addManualOrder') {
      this.checkMode = 'addManualOrder';
      this.addManualform.patchValue({
        orderType: {order_type:'Lots'}
      });
    } else if (this.data?.mode === 'addTapRequest') {
      this.checkMode = 'addTapRequest';
      this.addTapRequestform.patchValue({
        orderType: {order_type:'Lots'}
      });
    } else if (this.data?.mode === 'recalculate') {
      this.checkMode = 'recalculate';
      this.partNumber = this.data?.partNo;
    }

  }
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly dialogeRef: MatDialogRef<UvrActionDialogComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly spinner: NgxSpinnerService,
    public dialog: MatDialog
  ) {}
  get addComment() {
    return this.addCommentform.controls;
  }
  get addManual() {
    return this.addManualform.controls;
  }
  get addTapRequest() {
    return this.addTapRequestform.controls;
  }
  onLotsPiecesChange(event: any) {
    if (event.value.order_type === 'Pieces') {
      this.label = '# OF PIECES';
    } else if (event.value.order_type === 'Lots') {
      this.label = '# OF LOTS';
    }
  }
  commentError = '';
  saveComment() {
    // if (this.addCommentform.invalid) {
    //   this.submitted = true;
    //   return;
    // }
    // console.log(this.addComment, 'addComment');
    // console.log(this.addCommentform, 'addCommentform');
    if(this.addComment.comment.value.trim() == ''){
      this.commentError = 'Comment should not be empty.'
      return false;
    }else{
     this.commentError = '' 
    }
    const addEmittedData = {
      comment: this.addComment.comment.value.trim(), // Trim whitespace from the comment
    };

    // console.log(addEmittedData, 'addEmittedData');

    this.addCommentEventEmitter.emit(addEmittedData);
    this.dialogeRef.close();
  }
  recalculate() {
    this.addRecalculateEventEmitter.emit('recalculate');
    this.dialogeRef.close();
  }
  //for MAnual
  saveManualOrder() {
    if (this.addManualform.invalid) {
      this.submitted = true;
      return;
    }
    console.log(this.addManual, 'addManual');
    console.log(this.addManualform, 'addManualform');

    const addEmittedData = {
      qty: this.addManual.qty.value,
      order_type: this.addManual.orderType.value.order_type,
    };

    console.log(addEmittedData, 'addEmittedData');

    this.addManualOrderEventEmitter.emit(addEmittedData);
    this.dialogeRef.close();
  }

  //for MAnual
  saveTapRequest() {
    if (this.addTapRequestform.invalid) {
      this.submitted = true;
      return;
    }
    console.log(this.addTapRequest, 'addTapRequest');
    const addEmittedData = {
      qty: this.addTapRequest.qty.value,
      order_type: this.addTapRequest.orderType.value.order_type,

      date_by_when: this.addTapRequest.date_by_when.value,
    };

    this.addTapRequestEventEmitter.emit(addEmittedData);
    this.dialogeRef.close();
  }


  removeMessage() {}
  onInput(event: any): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9-]/g, '');

    // Ensure the minus sign is only at the beginning
    if (input.value.indexOf('-') > 0) {
      input.value = input.value.replace(/-/g, '');
      input.value = '-' + input.value;
    }
  }
}
